(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["download-catalogue"] && !Shopify.designMode) return;
  try {
    
  // (Optional) Lightweight click analytics hook:
  (() => {
    const root = document.getElementById('download-catalogue-{{ section.id }}');
    if (!root) return;
    const btn = root.querySelector('[data-dc="download-catalogue"]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      try {
        window.dispatchEvent(new CustomEvent('dc:download_catalogue_click', {
          detail: { sectionId: '{{ section.id }}', href: btn.getAttribute('href') }
        }));
      } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
